import { render, staticRenderFns } from "./SimpleListPopularPlaces.vue?vue&type=template&id=6bed78b2&"
import script from "./SimpleListPopularPlaces.vue?vue&type=script&lang=js&"
export * from "./SimpleListPopularPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports